import { Plus, Search, Clock, Briefcase, Sparkles, Sliders } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { SubTabId } from '@/components/Configuracao/esforcoTimeTypes'
import { ESFORCO_SUB_TABS } from '@/components/Configuracao/esforcoTimeTypes'

const SUB_TAB_ICONS: Record<SubTabId, React.ReactNode> = {
  marketing: <Sparkles size={13} />,
  suporte: <Clock size={13} />,
  projeto: <Briefcase size={13} />,
  criacao: <Sliders size={13} />,
}

type Props = {
  activeSubTab: SubTabId
  taskCounts: Record<SubTabId, number>
  searchQuery: string
  onSearchChange: (q: string) => void
  onSelectSubTab: (id: SubTabId) => void
  onAdd: () => void
}

export function EsforcoTimeToolbar({
  activeSubTab,
  taskCounts,
  searchQuery,
  onSearchChange,
  onSelectSubTab,
  onAdd,
}: Props) {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="flex items-center gap-1 p-1 bg-white/[0.04] rounded-lg border border-white/[0.06] w-fit">
        {ESFORCO_SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onSelectSubTab(tab.id)}
            className={cn(
              'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold whitespace-nowrap transition-all min-h-[44px]',
              activeSubTab === tab.id
                ? 'bg-accent text-white shadow-lg shadow-accent/20'
                : 'text-text-muted hover:text-text-primary hover:bg-white/[0.06]',
            )}
          >
            {SUB_TAB_ICONS[tab.id]}
            {tab.label}
            <span
              className={cn(
                'ml-1 px-1.5 py-0.5 rounded-full text-[9px]',
                activeSubTab === tab.id ? 'bg-white/20 text-white' : 'bg-white/[0.06] text-text-muted',
              )}
            >
              {taskCounts[tab.id]}
            </span>
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted" size={13} />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Buscar tarefa..."
            className="bg-white/[0.04] border border-white/[0.06] text-text-primary placeholder:text-text-muted rounded-md pl-8 pr-3 py-2 text-xs outline-none focus:border-accent transition-colors w-48 min-h-[44px]"
          />
        </div>
        <button
          type="button"
          onClick={onAdd}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold bg-accent text-white shadow-lg shadow-accent/20 hover:bg-accent/90 transition-all min-h-[44px]"
        >
          <Plus size={13} />
          Adicionar Tarefa
        </button>
      </div>
    </div>
  )
}
